module.exports = __webpack_public_path__ + "static/img/link-bg-company.d231cfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/link-bg-company.png
// module id = axD/
// module chunks = 2